import { useMemo, useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import {
  MONITOREOS_ESPECTACULARES,
  MONITOREOS_MEDIOS_IMPRESOS,
  MONITOREOS_INTERNET,
  MONITOREOS_VISITAS_VERIFICACION,
  ACTA_INICIO,
  ACTA_HALLAZGO,
  ACTA_CIERRE,
  EVENTOS,
  CASAS
} from 'constants/tipoMonitoreos';
import { Form } from 'antd';
import Accordion from './components/Accordion';
import Modal from '../Modal/Modal';
import './ReportesDinamicos.scss';
import SeccionMuestras from './components/SeccionMuestras';
import SeccionDatosGenerales from './components/SeccionDatosGenerales';
import SeccionBeneficiados from './components/SeccionBeneficiados';
import SeccionHallazgoMedios from './components/SeccionHallazgoMedios';
import SeccionObservaciones from './components/SeccionObservaciones';
import SeccionUbicacion from './components/SeccionUbicacion';
import SeccionServidoresPub from './components/SeccionServidoresPub';
import SeccionServidoresJunta from './components/SeccionServidoresJunta';
import SeccionRecorrido from './components/SeccionRecorrido';
import SeccionRepresentantes from './components/SeccionRepresentantes';
import SeccionHechos from './components/SeccionHechos';
import SeccionDatosHallazgos from './components/SeccionDatosHallazgos';
import SeccionUbicacionWeb from './components/SeccionUbicacionWeb';
import SeccionFirma from './components/SeccionFirma';
import SeccionAcuerdo from './components/SeccionAcuerdo';
import SeccionHallazgosInternet from './components/SeccionHallazgosInternet';
import SeccionVerificadores from './components/SeccionVerificadores';
import SeccionInicioVisita from './components/SeccionInicioVisita';
import SeccionCompareciente from './components/SeccionCompareciente';
import SeccionDocumentacion from './components/SeccionDocumentacion';
import SeccionTestigos from './components/SeccionTestigos';
import SeccionComplemento from './components/SeccionComplemento';
import SeccionContestacion from './components/SeccionContestacion';
import SeccionDesignado from './components/SeccionDesignado';

const ReportesDinamicos = ({
  visible,
  onClose,
  generarReporte,
  tipoMonitoreo,
  tipoActa,
  isLoading
}) => {
  const [formCampos] = Form.useForm();
  const [tituloModal, setTituloModal] = useState('');

  const handleClose = () => {
    onClose?.();
    formCampos.resetFields();
  };
  const handleOK = async () => {
    generarReporte?.(formCampos);
  };

  const getTipoMon = () => {
    switch (tipoMonitoreo) {
      case MONITOREOS_ESPECTACULARES:
        switch (tipoActa) {
          case ACTA_INICIO:
            setTituloModal('Acta de inicio');
            break;
          case ACTA_HALLAZGO:
            setTituloModal('Hallazgos');
            break;
          case ACTA_CIERRE:
            setTituloModal('Acta de cierre');
            break;
          default:
            break;
        }
        break;
      case MONITOREOS_MEDIOS_IMPRESOS:
        setTituloModal('Medios impresos');
        break;
      case MONITOREOS_INTERNET:
        setTituloModal('Internet');
        break;
      case MONITOREOS_VISITAS_VERIFICACION:
        switch (tipoActa) {
          case EVENTOS:
            setTituloModal('Eventos de Apoyo ciudadano, Precampaña o Campaña');
            break;
          case CASAS:
            setTituloModal('Casas de Apoyo ciudadano, Precampaña o Campaña');
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  };

  const items = useMemo(() => {
    getTipoMon();

    let sections = [];

    if (tipoMonitoreo === MONITOREOS_ESPECTACULARES) {
      if (tipoActa !== ACTA_HALLAZGO) {
        sections = [
          {
            key: 'datosGenerales',
            label: 'Datos Generales',
            forceRender: true,
            children: (
              <SeccionDatosGenerales
                form={formCampos}
                tipoMon={tipoMonitoreo}
                tipoActa={tipoActa}
              />
            )
          },
          {
            key: 'ubicacion',
            label: 'Ubicación',
            forceRender: true,
            children: (
              <SeccionUbicacion form={formCampos} tipoMon={tipoMonitoreo} tipoActa={tipoActa} />
            )
          },
          {
            key: 'servidoresPublicos',
            label: 'Servidores públicos',
            forceRender: true,
            children: <SeccionServidoresPub form={formCampos} />
          },
          {
            key: 'servidoresJuntaLocal',
            label: 'Servidores públicos de Junta Local (Opcional)',
            forceRender: true,
            children: <SeccionServidoresJunta form={formCampos} />
          },
          {
            key: 'recorrido',
            label: 'Vialidades a recorrer',
            forceRender: true,
            children: <SeccionRecorrido form={formCampos} />
          },
          {
            key: 'representantes',
            label: 'Representantes de Sujetos Obligados (Opcional)',
            forceRender: true,
            children: <SeccionRepresentantes form={formCampos} />
          },
          {
            key: 'hechos',
            label: 'Hechos (Opcional)',
            forceRender: true,
            children: <SeccionHechos form={formCampos} />
          }
        ];
      } else {
        sections = [
          {
            key: 'muestras',
            label: 'Muestras',
            forceRender: true,
            children: <SeccionMuestras form={formCampos} />
          },
          {
            key: 'datosGenerales',
            label: 'Datos Generales',
            forceRender: true,
            children: (
              <SeccionDatosGenerales
                form={formCampos}
                tipoMon={tipoMonitoreo}
                tipoActa={tipoActa}
              />
            )
          },
          {
            key: 'beneficiados',
            label: 'Beneficiados',
            forceRender: true,
            children: <SeccionBeneficiados form={formCampos} />
          },
          {
            key: 'hallazgo',
            label: 'Datos del hallazgo',
            forceRender: true,
            children: <SeccionDatosHallazgos form={formCampos} tipoMon={tipoMonitoreo} />
          },
          {
            key: 'ubicacion',
            label: 'Ubicación del hallazgo',
            forceRender: true,
            children: (
              <SeccionUbicacion form={formCampos} tipoMon={tipoMonitoreo} tipoActa={tipoActa} />
            )
          }
        ];
      }
    } else if (tipoMonitoreo === MONITOREOS_MEDIOS_IMPRESOS) {
      sections = [
        {
          key: 'muestras',
          label: 'Muestras',
          forceRender: true,
          children: <SeccionMuestras form={formCampos} />
        },
        {
          key: 'datosGenerales',
          label: 'Datos Generales',
          forceRender: true,
          children: (
            <SeccionDatosGenerales form={formCampos} tipoMon={tipoMonitoreo} tipoActa={tipoActa} />
          )
        },
        {
          key: 'beneficiados',
          label: 'Beneficiados',
          forceRender: true,
          children: <SeccionBeneficiados form={formCampos} />
        },
        {
          key: 'hallazgo',
          label: 'Datos del hallazgo',
          forceRender: true,
          children: <SeccionHallazgoMedios form={formCampos} />
        },
        {
          key: 'observaciones',
          label: 'Observaciones',
          forceRender: true,
          children: <SeccionObservaciones form={formCampos} />
        }
      ];
    } else if (tipoMonitoreo === MONITOREOS_INTERNET) {
      sections = [
        {
          key: 'hallazgos',
          label: 'Hallazgos',
          forceRender: true,
          children: <SeccionHallazgosInternet form={formCampos} tipoMon={MONITOREOS_INTERNET} />
        },
        {
          key: 'datosGenerales',
          label: 'Datos Generales',
          forceRender: true,
          children: (
            <SeccionDatosGenerales form={formCampos} tipoMon={tipoMonitoreo} tipoActa={tipoActa} />
          )
        },
        {
          key: 'beneficiados',
          label: 'Beneficiados',
          forceRender: true,
          children: <SeccionBeneficiados form={formCampos} />
        },
        {
          key: 'ubicacionWeb',
          label: 'Ubicación web del hallazgo',
          forceRender: true,
          children: <SeccionUbicacionWeb form={formCampos} />
        },
        {
          key: 'firmas',
          label: 'Firma',
          forceRender: true,
          children: <SeccionFirma form={formCampos} />
        },
        {
          key: 'acuerdo',
          label: 'Acuerdo de la COF',
          forceRender: true,
          children: <SeccionAcuerdo form={formCampos} />
        }
      ];
    } else if (tipoMonitoreo === MONITOREOS_VISITAS_VERIFICACION) {
      sections = [
        {
          key: 'datosGenerales',
          label: 'Datos Generales',
          forceRender: true,
          children: (
            <SeccionDatosGenerales form={formCampos} tipoMon={tipoMonitoreo} tipoActa={tipoActa} />
          )
        },
        {
          key: 'verificador',
          label: 'Verificador',
          forceRender: true,
          children: <SeccionVerificadores form={formCampos} />
        },
        {
          key: 'inicioVisita',
          label: 'Datos de inicio de visita',
          forceRender: true,
          children: <SeccionInicioVisita form={formCampos} />
        },
        {
          key: 'ubicacion',
          label: 'Ubicación de la visita',
          forceRender: true,
          children: (
            <SeccionUbicacion form={formCampos} tipoMon={tipoMonitoreo} tipoActa={tipoActa} />
          )
        },
        {
          key: 'beneficiados',
          label: 'Beneficiados',
          forceRender: true,
          children: <SeccionBeneficiados form={formCampos} />
        },
        {
          key: 'compareciente',
          label: 'Datos del compareciente (Opcional)',
          forceRender: true,
          children: <SeccionCompareciente form={formCampos} />
        },
        {
          key: 'hallazgos',
          label: 'Hallazgos',
          forceRender: true,
          children: <SeccionDatosHallazgos form={formCampos} tipoMon={tipoMonitoreo} />
        },
        {
          key: tipoActa === EVENTOS ? 'servidoresPublicos' : 'documentacion',
          label:
            tipoActa === EVENTOS
              ? 'Servidores públicos (Opcional)'
              : 'Documentación recibida (Opcional)',
          forceRender: true,
          children:
            tipoActa === EVENTOS ? (
              <SeccionServidoresPub form={formCampos} tipoMon={tipoMonitoreo} />
            ) : (
              <SeccionDocumentacion form={formCampos} />
            )
        },
        {
          key: 'testigos',
          label: 'Testigos',
          forceRender: true,
          children: <SeccionTestigos form={formCampos} />
        },
        {
          key: 'complementoVisita',
          label: 'Complemento de la visita',
          forceRender: true,
          children: <SeccionComplemento form={formCampos} tipoActa={tipoActa} />
        },
        {
          key: 'contestacionSujeto',
          label: 'Contestacion del Sujeto Obligado (Opcional)',
          forceRender: true,
          children: <SeccionContestacion form={formCampos} />
        },
        {
          key: 'designadoSujeto',
          label: 'Designado por el Sujeto Obligado (Opcional)',
          forceRender: true,
          children: <SeccionDesignado form={formCampos} />
        }
      ];
    }

    return sections;
  }, [tipoMonitoreo, tipoActa, formCampos]);

  return (
    <Modal
      title=""
      visible={visible}
      width="75em" // Se establece el tamaño asi por que antd sobreescribe el tamaño que se le pasa por clase
      onCancel={handleClose}
      onOk={handleOK}
      okText="Agregar a cola de descarga"
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{
        loading: isLoading,
        style: {
          borderColor: '#ffffff',
          color: '#ffffff',
          background: '#c12b7d'
        },
        className: 'custom-ok-button'
      }}>
      <div className="reportes-dinamicos">
        <div>
          <span className="reportes-dinamicos-title">Reporte dinámico</span>
          <span className="reportes-dinamicos-line"> | </span>
          <span className="reportes-dinamicos-title">{tituloModal}</span>
        </div>
        <div className="message-label">
          <span>
            <InfoCircleOutlined style={{ color: '#c12b7d', marginRight: '0.5rem' }} />
            Selecciona los campos requeridos en el reporte.
          </span>
        </div>

        <div className="accordion-campos">
          <Accordion items={items} />
        </div>
      </div>
    </Modal>
  );
};

ReportesDinamicos.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  generarReporte: PropTypes.func.isRequired,
  tipoMonitoreo: PropTypes.number.isRequired,
  tipoActa: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default ReportesDinamicos;
